"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TiersQueryDocument = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.TiersQueryDocument = (0, graphql_tag_1.default) `
  query Tiers {
    tiers {
      tier
      plugins {
        id
        name
        tier
      }
    }
  }
`;
